export type FlagKey = keyof typeof FLAGS;

export const FLAGS = {
  ar_market: require('@assets/images/asset/flag/ar_market.svg'),
  at_market: require('@assets/images/asset/flag/at_market.svg'),
  au_market: require('@assets/images/asset/flag/au_market.svg'),
  be_market: require('@assets/images/asset/flag/be_market.svg'),
  br_market: require('@assets/images/asset/flag/br_market.svg'),
  ca_market: require('@assets/images/asset/flag/ca_market.svg'),
  ch_market: require('@assets/images/asset/flag/ch_market.svg'),
  cl_market: require('@assets/images/asset/flag/cl_market.svg'),
  cn_market: require('@assets/images/asset/flag/cn_market.svg'),
  cz_market: require('@assets/images/asset/flag/cz_market.svg'),
  de_market: require('@assets/images/asset/flag/de_market.svg'),
  dk_market: require('@assets/images/asset/flag/dk_market.svg'),
  dr_market: require('@assets/images/asset/flag/dr_market.svg'),
  ee_market: require('@assets/images/asset/flag/ee_market.svg'),
  eg_market: require('@assets/images/asset/flag/eg_market.svg'),
  es_market: require('@assets/images/asset/flag/es_market.svg'),
  fi_market: require('@assets/images/asset/flag/fi_market.svg'),
  fr_market: require('@assets/images/asset/flag/fr_market.svg'),
  gb_market: require('@assets/images/asset/flag/gb_market.svg'),
  hk_market: require('@assets/images/asset/flag/hk_market.svg'),
  hu_market: require('@assets/images/asset/flag/hu_market.svg'),
  id_market: require('@assets/images/asset/flag/id_market.svg'),
  ie_market: require('@assets/images/asset/flag/ie_market.svg'),
  il_market: require('@assets/images/asset/flag/il_market.svg'),
  in_market: require('@assets/images/asset/flag/in_market.svg'),
  it_market: require('@assets/images/asset/flag/it_market.svg'),
  jp_market: require('@assets/images/asset/flag/jp_market.svg'),
  kr_market: require('@assets/images/asset/flag/kr_market.svg'),
  lk_market: require('@assets/images/asset/flag/lk_market.svg'),
  lt_market: require('@assets/images/asset/flag/lt_market.svg'),
  lv_market: require('@assets/images/asset/flag/lv_market.svg'),
  mx_market: require('@assets/images/asset/flag/mx_market.svg'),
  my_market: require('@assets/images/asset/flag/my_market.svg'),
  nl_market: require('@assets/images/asset/flag/nl_market.svg'),
  no_market: require('@assets/images/asset/flag/no_market.svg'),
  nz_market: require('@assets/images/asset/flag/nz_market.svg'),
  pl_market: require('@assets/images/asset/flag/pl_market.svg'),
  pt_market: require('@assets/images/asset/flag/pt_market.svg'),
  qa_market: require('@assets/images/asset/flag/qa_market.svg'),
  ru_market: require('@assets/images/asset/flag/ru_market.svg'),
  se_market: require('@assets/images/asset/flag/se_market.svg'),
  sg_market: require('@assets/images/asset/flag/sg_market.svg'),
  sr_market: require('@assets/images/asset/flag/sr_market.svg'),
  th_market: require('@assets/images/asset/flag/th_market.svg'),
  tr_market: require('@assets/images/asset/flag/tr_market.svg'),
  tw_market: require('@assets/images/asset/flag/tw_market.svg'),
  uk_market: require('@assets/images/asset/flag/uk_market.svg'),
  us_market: require('@assets/images/asset/flag/us_market.svg'),
  ve_market: require('@assets/images/asset/flag/ve_market.svg'),
  za_market: require('@assets/images/asset/flag/za_market.svg')
};

export const langToFlag: Record<string, FlagKey> = {
  sv: 'se_market',
  en: 'us_market'
};
